import React, { useEffect, useState } from 'react';
import { getReclamos } from '../../service/apiBackEnd.js';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';

const Reclamos = () => {

    const [allData, setAllData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getReclamos();
            console.log("DATA", res);
            setAllData(res);
        };
        fetchData();
    }, []);

    console.log("DATAAAA reclamos", allData);

    return (
        <Container>
            <Row>
                <h1 className="mt-5 mb-4">Reclamos por deficiencias en el servicios</h1>
                <hr></hr>
                <h3>SR. USUARIO:</h3>
                {allData.map((elem, index) => {
                    return (
                        <>
                            <Col lg={12}>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.txt_usuario,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <h3>Normativa de Derroche</h3>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.normativa_de_derroche,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <h3>Consulte leyes, decretos, contratos y otras resoluciones regulatorias DIRCAS en Marco Legal</h3>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.sistema_de_facturacion_por_cuota_fija
                                            ,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.sistema_de_facturacion_de_cuota_fija_mas_exceso
                                            ,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.sistema_de_facturacion_por_servicio_medido_o_volumetrico
                                            ,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <h3>Responsabilidad en la Conexión</h3>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.responsabilidad_en_la_conexion
                                            ,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>
                            <Col lg={12}>
                                <h3 className='mb-4'>Emergencia del servicio</h3>
                                <div key={index}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: elem.acf?.emergencia_del_servicio
                                            ,
                                        }}
                                    />
                                    <hr />
                                </div>
                            </Col>

                        </>
                    )
                })}
            </Row>
        </Container>
    )
}

export default Reclamos